import type { NeedsYouDismissalList } from '@tenfour/contracts'
import { api } from '@/lib/api'

export interface RecordNeedsYouDismissalInput {
  resolutionType: 'DISMISSED'
  itemKey: string
  /** Required for a `conversation:` item (its evidence snapshot); absent otherwise. */
  conversationId?: string
  sourceEventAt: string
  /** Legible label for a non-conversation dismissal. */
  title?: string
  aiSuggestion?: string
  feedback?: string
}

export interface NeedsYouResolutionReceipt {
  id: string
  resolutionType: 'DISMISSED'
  feedbackStored: boolean
}

export function recordNeedsYouDismissal(
  input: RecordNeedsYouDismissalInput,
): Promise<NeedsYouResolutionReceipt> {
  return api('/needs-you/resolutions', {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

/**
 * What this account has dismissed (#553) — the cross-device read the Home feed
 * merges before rendering, so a card dismissed on the phone is gone on the
 * laptop. Each entry is scoped to the item's revision (`sourceEventAt`), so new
 * activity brings the card back on its own.
 */
export function fetchNeedsYouDismissals(): Promise<NeedsYouDismissalList> {
  return api('/needs-you/resolutions')
}
